import gql from "graphql-tag";

const DELETE_ORDER_MUTATION = gql`  
mutation DeleteOrder($orderId: String!) {
    deleteOrder(orderId: $orderId)
}`;

export default DELETE_ORDER_MUTATION;